import React from 'react'
import './contactform.css';
import { TextAreaResize } from '../../chatbot/components/textarearesize';
import { ToastManager, TOAST_TYPES } from '../../fasades/toastmanager';

interface State {
    email     : string;
    name      : string;
    company   : string;
    message   : string;
    subscribe : string;
};


export class ContactForm extends React.Component<{}, State> {

    constructor(props : {}) {
        super(props);

        this.state = {
          name    : '',
          email   : '',
          company : '',
          message : '',
          subscribe : ''
        };
    }

    handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) 
    {
         this.setState({ [e.target.name]: e.target.value } as Pick<State, keyof State>);
    }

    handleChangeMessage(text : string)
    {
        this.setState({ message : text });
    }

    async handleSubmit(e: React.FormEvent<HTMLFormElement>) 
    {
        e.preventDefault();  // This stops the page refresh

        const response = await fetch('/v1/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(this.state)
        });

        if (!response.ok) {
            ToastManager.addToast("Failed to send message! Contact us via email: info@tigercity.ai instead!", TOAST_TYPES.ERROR, -1);
        }
        else {
            ToastManager.addToast("Message Send!", TOAST_TYPES.SUCCESS, 5000);

            this.setState( {
                name      : '',
                email     : '',
                company   : '',
                message   : '',
                subscribe : ''
            });
        }
    }

    handleKeyDown(e : React.KeyboardEvent<HTMLInputElement>)
    {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    }

    render() {
        return (
            <div className="contact">
                <div className = "contact-heading">
                    <h2>Contact us</h2>
                </div>
                <form method="POST" className="contact-form" action="/v1/contact"  onSubmit={(e) => this.handleSubmit(e) }>
                    <div className="contact-input">
                        <input 
                            id          = "email"
                            name        = "email"
                            placeholder = "Business Email*"
                            type        = "email"
                            onChange    = {(e) => this.handleChange(e) }
                            value       = {this.state.email} />
                    </div>
                    <div className="contact-input">
                        <input  
                            id           = "name"
                            name         = "name"
                            placeholder  = "Name*"
                            type         = "text"
                            inputMode    = "text"
                            autoComplete = "name"
                            onKeyDown    = { (e) => this.handleKeyDown(e) }
                            onChange     = {(e) => this.handleChange(e) }
                            value        = { this.state.name }/>
                    </div>
                    <div className="contact-input">
                        <input
                            id           = "company"
                            name         = "company"
                            placeholder  = "Company if any *"
                            type         = "text"
                            inputMode    = "text"
                            autoComplete = "organization"
                            onKeyDown    = { (e) => this.handleKeyDown(e) }
                            onChange     = {(e) => this.handleChange(e) }
                            value        = { this.state.company }/>
                    </div>
                    <div className="contact-input">
                        <TextAreaResize
                            id          = "message"
                            name        = "message"
                            className   = "contract-textarea"
                            editMode    = {true}
                            placeholder = "Message*"
                            minRows     = { 4 }
                            onChange    = {(text) => this.handleChangeMessage(text) }
                            text        = {this.state.message}/>
                    </div>
                    <div className="contact-input">
                        <div className="checkbox">
                            <input 
                                id       = "subscribe"
                                name     = "subscribe"
                                type     = "checkbox"
                                onKeyDown    = { (e) => this.handleKeyDown(e) }
                                onChange = {(e) => this.handleChange(e) }
                            />
                            <span suppressHydrationWarning={true}>Subscribe to our newsletter.</span>
                        </div>
                    </div>

                    <div className="contact-actions">
                        <input type="submit" className="btn" value="Send"/>
                    </div>
                </form>
            </div>
        )
    }
}

